"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.map = void 0;
const create_fn_1 = require("../utils/create-fn");
const get_arg_1 = require("../utils/get-arg");
// NEW
/*
## fn.map.concat

Create a new map by concatenating all the maps passed in.

### Arguments

1-Infinity. (Map) The maps to concatenate.

Returns the concatenated map. (Map)
*/
const concat = (0, create_fn_1.createFn)("fn.map.concat", (args, context) => {
    const result = new Map();
    for (let i = 1; i <= args.length; i++) {
        const map = (0, get_arg_1.getArgMap)(args, i, context);
        for (const [key, value] of map) {
            result.set(key, value);
        }
    }
    return result;
});
// NEW
/*
## fn.map.fromparallellists

Create a map from two parallel lists. The first list becomes the keys, and the second list becomes the values.

### Arguments

1. (array) The list of keys.
2. (array) The list of values.

Returns the map. (Map)
*/
const fromparallellists = (0, create_fn_1.createFn)("fn.map.fromparallellists", (args, context) => {
    const keys = (0, get_arg_1.getArgArray)(args, 1, context);
    const values = (0, get_arg_1.getArgArray)(args, 2, context);
    const map = new Map();
    for (const [index, key] of keys.entries()) {
        map.set(String(key), values[index]);
    }
    return map;
});
exports.map = {
    concat,
    fromparallellists,
};
//# sourceMappingURL=map.js.map